import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { TinyAreaChart } from "../../Common/Charts/TinyAreaChart";
import { number_format } from "Utils";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class SimpleValueAndTinyChartComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      component,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      layoutProps: { scaleComponent }
    } = this.props;

    const {
      componentId,
      labels,
      data: { account, data },
      config: { annexeAttachmentCategory }
    } = component;

    const {
      percentage,
      code,
      currentValue,
      diffValue,
      unit,
      notAvailable,
      isOneYearDashboard
    } = account[0];

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={percentage}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.SimpleValueAndTinyChartComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container,
            scaleComponent ? styles.scale_component : null
          )}
        >
          {!this.props.inSlideView && (
            <ComponentActions
              removeComponent={this.props.handleRemoveComponent}
              updateComponent={this.props.handleUpdateComponent}
              componentCase={this.props.ComponentCase}
              sideBar={"ComponentConfig"}
              component={"SimpleValueAndTinyChartComponent.png"}
            />
          )}
          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <span
              className={classnames("medium-12 small-12", styles.main_value)}
            >
              {notAvailable
                ? currentValue
                : number_format(currentValue, 2, ",", " ")}{" "}
              {unit !== "none" ? unit : ""}
            </span>
            <span
              className={classnames(
                "medium-12 small-12",
                styles.sub_value,
                percentage > 0 ? styles.positive_value : styles.negative_value
              )}
            >
              {notAvailable
                ? _("notAvailable")
                : percentage !== null
                  ? percentage > 0
                    ? _("increaseOf")
                    : _("decreaseOf")
                  : ""}{" "}
              {percentage ? (
                <span className={styles.positive_value}>
                  {notAvailable ? "" : number_format(diffValue, 2, ",", " ")}{" "}
                  {unit !== "none" ? unit : ""}
                </span>
              ) : (
                ""
              )}
              {/*{isOneYearDashboard ? "" : <br />}*/}
              {/*{lastYear ? (*/}
              {/*  <span className={styles.year_info}>*/}
              {/*    de <b>{lastYear}</b> à <b>{currentYear}</b>*/}
              {/*  </span>*/}
              {/*) : currentYear ? (*/}
              {/*  <span className={styles.year_info}>*/}
              {/*    à l'année <b>{currentYear}</b>*/}
              {/*  </span>*/}
              {/*) : (*/}
              {/*  ""*/}
              {/*)}*/}
            </span>
          </div>

          {!isOneYearDashboard ? (
            <span
              className={classnames(
                "medium-12 small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <TinyAreaChart
                chartData={Object.values(data)}
                dataKeyY={code}
                dataKeyX={"year"}
                status={percentage > 0}
              />
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default SimpleValueAndTinyChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/SimpleValueAndTinyChartComponent.js